import http from "../../http";

const index = {
  terminalGroupList(r) {
    return http.get("/gateway/apps/o2o/api/terminal/terminalGroupList", r);
  }
}

export default index;
